import type { ComponentType } from 'react';
import type { ExerciseType } from '../../types/content';
import type { ExercisePluginProps } from './types';
import { ChoiceExercise } from './plugins/ChoiceExercise';
import { GuidedExposureExercise } from './plugins/GuidedExposureExercise';
import { OpenResponseExercise } from './plugins/OpenResponseExercise';
import { PronunciationExercise } from './plugins/PronunciationExercise';
import { RetrievalExercise } from './plugins/RetrievalExercise';

export const exerciseRegistry: Record<ExerciseType, ComponentType<ExercisePluginProps>> = {
  'guided-exposure': GuidedExposureExercise,
  recognition: ChoiceExercise,
  retrieval: RetrievalExercise,
  construction: OpenResponseExercise,
  reformulation: OpenResponseExercise,
  listening: ChoiceExercise,
  pronunciation: PronunciationExercise,
  'extended-production': OpenResponseExercise,
  conversation: OpenResponseExercise,
  'error-repair': OpenResponseExercise
};
